import { useEffect } from 'react';

const TYGER_LOGIN_URL = 'https://tyger.crego.ai/login';

/**
 * The borrower login experience has moved to v2 (tyger).
 * This component keeps the legacy `auth/login/borrower` route alive
 * by hard-redirecting to the new page.
 */
const BorrowerLoginRedirect = () => {
    useEffect(() => {
        window.location.replace(TYGER_LOGIN_URL);
    }, []);

    return (
        <div className='d-flex flex-column align-items-center justify-content-center py-10'>
            <span className='spinner-border text-primary mb-5'></span>
            <div className='text-gray-500 fw-semibold fs-6'>
                Redirecting you to{' '}
                <a
                    href={TYGER_LOGIN_URL}
                    className='link-primary'>
                    {TYGER_LOGIN_URL}
                </a>
            </div>
        </div>
    );
};

export { TYGER_LOGIN_URL };
export default BorrowerLoginRedirect;
